import type { PartialStoreState } from '../typings'

export const selectAlerts = (state: PartialStoreState) =>
  state.domain.publicData.domain.gps.wwgps.eventAlerts
